import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { AxAlert } from "../../Limestone/AxAlert/AxAlert";
import { wtpScanner } from "../../Lib/Helper/wtpScanner";
import { inputMaskHelper } from "../../Lib/Helper/InputMaskHelper";

@ModuleName("MyChipCards")
export class MyChipCards implements AxInit {

    private keyList = {
        listClass: '.myChipCards__list',
        detailClass: '.myChipCards__details'
    };

    constructor(private _wtpScanner = new wtpScanner()) {}

    AxInit(init): void {
        this.subNavEvents();
        
        $('.myChipCards__ticketList-details').click(x => {
            let $target = $(x.delegateTarget);
            let data = {
                wtpNr: $target.attr('data-wtpNr'),
                projNr: $target.attr('data-projNr'),
                posNr: $target.attr('data-posNr'),
                serialNr: $target.attr('data-serialNr'),
                validFrom: $target.attr('data-valid'),
            }

            AxessViewer.loadPartialView('/FindMyTicket/_Details',
                data,
                resp => {
                    $('body, main').addClass('ax-bg-white');
                    $(this.keyList.listClass).addClass('d-none');
                    $(this.keyList.detailClass).html(resp.view);
                    this.registerDetailEvents();
                },
                {});
        });
        
        this._wtpScanner.initQrCodeScanner({
            $activationButton: $('.scan-qr-button'),
            $modal: $('#webcam_modal'),
            resultTarget: document.querySelector('.wtp-input'),
            videoElem: document.getElementById('qr-video') as HTMLVideoElement
        });

        $('.myChipCards__ticketList-details-btn').click(x => {
            let target = $(x.delegateTarget).attr('data-target');
            $(x.delegateTarget).find('i').toggleClass('la-angle-down').toggleClass('la-angle-up');
            $(`.myChipCards__ticketList-details-block[data-target=${target}]`).toggleClass('d-none');
        });
        
        $('.openPass-input').inputmask("9999 9999 9999 9999 9999-999", inputMaskHelper.openpassMaskOptions());
        $('.wtp-input').inputmask({
            mask: inputMaskHelper.wtpNumberMask(),
            ...inputMaskHelper.wtpMaskOptions()
        });
    }


    subNavEvents() {
        $('.myChipCards__subNav li').click(x => {
            $('.myChipCards__subNav li').removeClass('active');
            $(x.delegateTarget).addClass('active');
            let target = $(x.delegateTarget).attr('data-target');
            $('.myChipCards__content > div').removeClass('active');
            $(`.myChipCards__content > div[data-target=${target}]`).addClass('active');
        });
    }

    registerDetailEvents() {
        new AxAlert('.myChipCards__details .ax-alert-banner');
        $('.findMyTickets__details-button').click(x => {
            $(this.keyList.detailClass).html('');
            $('body, main').removeClass('ax-bg-white');
            $(this.keyList.listClass).removeClass('d-none');
        });
    }
}